import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, branch, renderComponent } from 'recompose'

import FileType from './FileType'
import UploadProgress from './UploadProgress'
import Dropzone from 'components/custom/FileDropzone/index'

import {
  PAGE
} from './constants'

const UploadPage = compose(
  branch(
    ({ page }) => page === PAGE.FILE_SELECTION,
    renderComponent(Dropzone)
  ),
  branch(
    ({ page }) => page === PAGE.UPLOADING,
    renderComponent(UploadProgress)
  )
)(FileType)

export default UploadPage
